import { VALID_PROMOTIONS } from 'views/components/organisms/ProductLabels/consts'

export const getPromotionLabelText = (promotion, promotionProduct) =>
  promotion && VALID_PROMOTIONS.includes(promotion)
    ? null
    : promotionProduct.ribbonText
